import styled from 'styled-components';
import { remCalc } from '@lux/helpers';

import Anchor from '../Anchor';
import Row from '../Row';
import Theme from '../../theme';

export default {
  FooterLinksRow: styled(Row)`
    margin-top: ${remCalc(40)};
    margin-bottom: ${remCalc(40)};
  `,
  FooterPagesRow: styled(Row)`
    margin-top: ${remCalc(40)};
    margin-bottom: ${remCalc(40)};
    display: none;
    ${Theme.media.lg`
      display: flex;
    `};
  `,
  Divider: styled.hr`
    border: none;
    border-bottom: 1px solid ${Theme.colours.grey_c6};
    display: none;
    ${Theme.media.md`
      display: block;
    `};
  `,
  FlexGrid: styled.div`
    display: flex;
    flex-direction: column;

    ${Theme.media.md`
      flex-direction: row;
    `};
  `,
  Navigation: styled.nav`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    flex-direction: column;
    ${Theme.media.md`
      flex-direction: row;
    `};
  `,
  HeadingAnchor: styled(Anchor)`
    && {
      font-family: ${Theme.fonts.families.AvenirHeavy};
      font-size: ${remCalc(14)};
      color: ${Theme.colours.black};
      margin-bottom: ${remCalc(10)};
      display: block;

      &:hover {
        color: ${Theme.colours.black};
      }
    }
  `,
  FooterPage: styled.div`
    margin-bottom: ${remCalc(10)};
  `,
  FooterPageAnchor: styled(Anchor)`
    && {
      font-family: ${Theme.fonts.families.AvenirBook};
      font-size: ${remCalc(14)};
      color: ${Theme.colours.grey_c6};

      &:hover {
        color: ${Theme.colours.grey_c6};
      }
    }
  `,
  Anchor: styled(Anchor)`
    && {
      font-family: ${Theme.fonts.families.AvenirHeavy};
      text-transform: uppercase;
      color: ${Theme.colours.grey_c6};
      font-size: ${remCalc(12)};
      flex: 1 1 auto;
      text-align: center;
      margin-bottom: 2.5rem;

      &:hover {
        color: ${Theme.colours.grey_c6};
      }
      ${Theme.media.md`
        flex: 0 1 auto;
        margin-right: 1.4rem;
        text-align: left;
        margin-bottom: 0;
      `};
    }
  `,
  Copyright: styled.div`
    font-family: ${Theme.fonts.families.AvenirBook};
    font-size: ${remCalc(12)};
    letter-spacing: 0.015em;
    white-space: nowrap;
    color: ${Theme.colours.grey_c6};
    flex: 1 1 auto;
    text-align: center;
    ${Theme.media.md`
      text-align: right;
      margin-left: 1rem;
    `};
  `,
  Social: styled.div`
    margin: ${remCalc(20)} 0 ${remCalc(10)};
    text-align: center;

    ${Theme.media.md`
      margin-top: ${remCalc(10)};
      text-align: right;
    `};
  `,
  SocialLink: styled(Anchor)`
    display: inline-block;
    margin: 0 15px;

    ${Theme.media.md`
      margin: 0 0 0 8px;
    `};
  `,
  SocialIcon: styled.img`
    margin: 0;
    height: 30px;
  `
};
